module.exports = __webpack_public_path__ + "static/media/Nunito-SemiBold.82c3a6e2.ttf";